import React, { useState, useEffect } from "react";
import "./EmployeeFilter.css";
import config from "../../config";


const EmployeeFilter = ({ visible, onClose, onApply }) => {

  const [gender, setGender] = useState("");
  const [clientName, setClientName] = useState("");
  const [subVendor, setSubVendor] = useState("");
  const [jobRole, setJobRole] = useState("");
  const [workSite, setWorkSite] = useState("");
  const [status, setStatus] = useState("");
  const [sortBy, setSortBy] = useState("");
const [subVendors, setSubVendors] = useState([]);
const [jobRoles, setJobRoles] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [userDetails, setUserDetails] = useState({
    token: "",
    orgId: ""
  });

  // Reset when modal closed
  useEffect(() => {
    if (!visible) {
      setGender("");
      setClientName("");
      setSubVendor("");
      setJobRole("");
      setWorkSite("");
      setStatus("");
      setSortBy("");
    }
  }, [visible]);

  useEffect(() => {
  if (!userDetails.token || !userDetails.orgId) return;

  fetchJobRoles();
}, [userDetails.token, userDetails.orgId]);

  const fetchJobRoles = async () => {
  try {
    const response = await fetch(
      `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${userDetails.orgId}?configType=JobRole`,
      {
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
          "Content-Type": "application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch JobRole");
    }

    const data = await response.json();

    const activeItems = (Array.isArray(data) ? data : []).filter(
      (item) => item && item.isActive
    );

    const valuesList = activeItems
      .map((item) =>
        typeof item.values === "string" ? item.values.trim() : ""
      )
      .filter(Boolean);

    const uniqueRoles = [...new Set(valuesList)];

    setJobRoles(uniqueRoles);
  } catch (err) {
    console.error("JobRole API Error:", err);
    setJobRoles([]);
  }
};
  // Get orgId + token
  useEffect(() => {
    const orgId = localStorage.getItem("orgId") || "";
    const token = localStorage.getItem("Authorization") || "";
    setUserDetails({ orgId, token });
  }, []);

  // Fetch Clients
  useEffect(() => {
    const fetchClients = async () => {
      if (!userDetails.orgId || !userDetails.token) return;

      try {
        const response = await fetch(
          `${config.API_BASE_URL}${config.CLIENT_LIST_ENDPOINT}${userDetails.orgId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${userDetails.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch clients");

        const data = await response.json();
        setClientList(Array.isArray(data.body) ? data.body : []);
      } catch (error) {
        console.error("Client fetch error:", error);
        setClientList([]);
      }
    };

    fetchClients();
  }, [userDetails.orgId, userDetails.token]);

  useEffect(() => {
  if (!userDetails.token || !userDetails.orgId) return;

  const fetchSubVendors = async () => {
    try {
      const url = `${config.API_BASE_URL}${config.SUBVENDOR_LIST_ENDPOINT}?orgKey=${userDetails.orgId}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
          "Content-Type": "application/json",
        },
        credentials: "include",
      });

      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }

      const data = await response.json();
      const vendors = Array.isArray(data?.body) ? data.body : [];

      setSubVendors(vendors);
    } catch (err) {
      console.error("SubVendor API Error:", err);
      setSubVendors([]);
    }
  };

  fetchSubVendors();
}, [userDetails.token, userDetails.orgId]);
  if (!visible) return null;

  const handleApply = () => {
    const filters = {
      gender,
      clientName,
      subVendor,
      jobRole,
      workSite,
      status,
      sortBy
    };
    onApply?.(filters);
    onClose?.();
  };

 const handleClear = () => {
    // 1. Reset all local states
    setGender("");
    setClientName("");
    setSubVendor("");
    setJobRole("");
    setWorkSite("");
    setStatus("");
    setSortBy("");

    // 2. Trigger onApply with empty values to reset the main table view
    onApply?.({}); 

    // 3. Close the filter modal
    onClose?.(); 
  };

  return (
    <div className="ef-overlay" onMouseDown={onClose}>
      <div
        className="ef-card"
        onMouseDown={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="ef-header">Filter</div>

        <div className="ef-body">

          <label className="ef-label">Gender</label>
          <select className="ef-select" value={gender} onChange={(e) => setGender(e.target.value)}>
            <option value=""></option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>

          <label className="ef-label">Client Name</label>
          <select
            className="ef-select"
            value={clientName}
            onChange={(e) => setClientName(e.target.value)}
          >
            <option value="">All Clients</option>
            {clientList.map((client) => (
              <option key={client.clientKey} value={client.clientKey}>
                {client.name}
              </option>
            ))}
          </select>

          <label className="ef-label">Sub Vendor</label>
          <select
  className="ef-select"
  value={subVendor}
  onChange={(e) => setSubVendor(e.target.value)}
>
  <option value="">All Sub Vendors</option>
  {subVendors.map((vendor, index) => (
    <option
      key={vendor.subVendorKey ?? index}
      value={vendor.subVendorName || vendor.name}
    >
      {vendor.subVendorName || vendor.name}
    </option>
  ))}
</select>

          <label className="ef-label">Job Role</label>
         <select
  className="ef-select"
  value={jobRole}
  onChange={(e) => setJobRole(e.target.value)}
>
  <option value="">All Job Roles</option>
  {jobRoles.map((role, index) => (
    <option key={index} value={role}>
      {role}
    </option>
  ))}
</select>

          <label className="ef-label">Work Site</label>
          <select className="ef-select" value={workSite} onChange={(e) => setWorkSite(e.target.value)}>
            <option value=""></option>
          </select>

          <label className="ef-label">Status</label>
          <select className="ef-select" value={status} onChange={(e) => setStatus(e.target.value)}>
            <option value=""></option>
            <option value="Active">Active</option>
            <option value="In Active">In Active</option>
          </select>

          <label className="ef-label">Sort By</label>
          <select className="ef-select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <option value=""></option>
            <option value="name">Employee Name</option>
            <option value="clientName">Client Name</option>
            <option value="role">Job Role</option>
            <option value="status">Status</option>
          </select>

        </div>

        <div className="ef-footer">
          <button className="ef-btn ef-clear" onClick={handleClear}>Clear</button>
          <button className="ef-btn ef-apply" onClick={handleApply}>Apply</button>
        </div>
      </div>
    </div>
  );
};

export default EmployeeFilter;